module.exports = __webpack_public_path__ + "media/images/category_icons/clips-6602ff2250e9e0bdd8ea026de89994b8.svg";